import { SessionStorageKeyEnum } from '../types';

export default class SessionStorageService {
  static setItem(key: SessionStorageKeyEnum, value: string) {
    try {
      sessionStorage.setItem(key, value);
    } catch (e) {}
  }

  static getItem(key: SessionStorageKeyEnum) {
    try {
      return sessionStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  static removeItem(key: SessionStorageKeyEnum) {
    try {
      sessionStorage.removeItem(key);
    } catch (e) {}
  }

  static clear() {
    try {
      sessionStorage.clear();
    } catch (e) {}
  }
}
